import { Fragment, useCallback, useEffect, useState } from 'react'
import { ModalMedium } from '../../../../../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../../../../../utils/reducers/getters'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import { QuoteOrderModelType } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { ButtonPrimary } from '../../../../../../../../../../baseComponents/Button'
import location from '../../../../../../../../../../utils/globals/locations'
import { displayDateTime } from '../../../../../../../../../../utils/globals/date'
import LoadingSpinner from '../../../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { Link } from 'react-router-dom'
import PermissionChecker from '../../../../../../../../../../baseComponents/PermissionChecker'
import { CustomCustomerRenderWithLabel } from '../../../../../../../../../../specificComponents/Customers/Subcomponents'
import useQuoteStatus from '../../../../../../../../../../utils/hooks/quotes/useQuoteStatus'

interface ModalAdminDeniedQuoteProps extends ModalAdminDeniedQuoteLogicProps {
}

const ModalAdminDeniedQuote: React.FC<ModalAdminDeniedQuoteProps> = ({ setOpened, allRowData, onSubmit }) => {
    const { t } = useTwinTranslation()
    const parsedExtraData = JSON.parse(allRowData?.extraData)
    const { data } = useModalAdminDeniedQuoteLogic({ allRowData, setOpened, onSubmit })
    const { quoteStatus } = useQuoteStatus()

    const userPermission = getUserPermissions('quote.order')
    if (userPermission) {
        let renderThis: JSX.Element = <LoadingSpinner />
        if (data) {
            const fields: FormRender<TwinDictionary> = [
                {
                    cols: 2,
                    elements: [
                        {
                            name: 'full_assigned_number',
                            component: 'TextField',
                            label: t('quoteN', 'Nº presupuesto'),
                            value: data?.full_assigned_number,
                        },
                        {
                            name: 'CustomerId',
                            component: 'Custom',
                            render: () => <CustomCustomerRenderWithLabel label={t('customer', 'Cliente')} allRowData={{ Customer: data?.Customer }} />,
                        },
                        {
                            name: 'status',
                            component: 'TextField',
                            label: t('status', 'Estado'),
                            value: quoteStatus[data?.status]
                        },
                        {
                            name: 'processedDate',
                            component: 'TextField',
                            label: t('canceledDate', 'Fecha de cancelación'),
                            value: displayDateTime(new Date(parsedExtraData?.processedDate))
                        },
                    ]
                },
            ]
            renderThis = (
                <Fragment>
                    <div className='mb-25'>
                        <h2><TwinTrans transKey='notificationInfo'>Información de la notificación</TwinTrans></h2>
                    </div>
                    <div className={'flex flex-auto flex-col h-1'}>
                        <div className='overflow-auto flex flex-col notFlexAutoFormRender'>
                            <FormRenderer sections={fields} className='grid_mincontent' />
                        </div>
                        <div className='flex w-full justify-end mt-auto'>
                            <Link to={location?.quoteOrderSingle + '/' + data?.id}>
                                <ButtonPrimary>Ir al presupuesto</ButtonPrimary>
                            </Link>
                        </div>
                    </div>
                </Fragment>
            )
        }
        return (
            <PermissionChecker userPermissions={userPermission} permission={'read'}>
                <ModalMedium opened={true} setOpened={setOpened} className={'flex flex-col'}>
                    {renderThis}
                </ModalMedium>
            </PermissionChecker>
        )
    }
    return null
}

interface ModalAdminDeniedQuoteLogicProps extends ModalEditComponentProps{
}

const useModalAdminDeniedQuoteLogic = ({ allRowData }: ModalAdminDeniedQuoteLogicProps) => {
    const [data, setData] = useState<QuoteOrderModelType | null>(null)
    const getQuoteOrderData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/quote/getQuoteOrderComplete', { id: allRowData?.SubId })
        if (result) {
            setData(result.header)
        }
    }, [setData, allRowData?.SubId])

    useEffect(() => {
        getQuoteOrderData()
    }, [getQuoteOrderData])

    return { data }
}

export default ModalAdminDeniedQuote